import React, { useEffect, useRef, useState } from "react";
import MobileLayout from "../MobileLayout";
import "./gameResult.css";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { getUserRank } from "../home-section/services";
import { useTranslation } from "react-i18next";
import mixpanel from "../mixpanel/mixpanelWrapper";
import { getPersonalScoreByUserId } from "../apis/UserApis";
import { getRankImage, RankImage } from "../utility/GetRank";
import { useNavigate } from "react-router";
import BreefReportService from "./BreefReportService";

const GameResult = () => {
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const [rankImage, setRankImage] = useState<RankImage>({ imageUrl: null });
  const smFname = useSelector((state: RootState) => state.onboard.firstname);
  const smLname = useSelector((state: RootState) => state.onboard.lastname);
  const smEmail = useSelector((state: RootState) => state.onboard.email);
  const smPhone = useSelector((state: RootState) => state.onboard.phone);
  const smUserID = useSelector((state: RootState) => state.onboard.userID);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">("success");
  const [breefCount, setBreefCount] = useState<number>(0);
  const totalScore = useRef<number>(0);
  const [isTracked, setIsTracked] = useState(false);
  const navigate = useNavigate();
  const newUser = useSelector((state: RootState) => state.onboard.newUser);
  console.log("SM: ", smFname, smLname, smEmail, smPhone, smUserID);
  const points = useSelector((state: RootState) => state.score.points);
  const duration = useSelector((state: RootState) => state.score.duration);
  const quizScore = useSelector((state: RootState) => state.score.quizScore);
  const sessionQuizScore = Number(sessionStorage.getItem("quizScore"));
  const gameScore = Number(sessionStorage.getItem("gameScore"));
  totalScore.current = (quizScore || sessionQuizScore) + (points || gameScore)
  
  console.log("points", points)
  useEffect(() => {
    if (!isTracked) {
      mixpanel.track("Dashboard Viewed", {
        current_page: "dashboard",
      });
      console.log("Dashboard Viewed");

      setIsTracked(true);
    }
    fetchTotalScoreById();
  }, [isTracked]);

  const fetchTotalScoreById = async () => {
    try {
      const totalScore = await getPersonalScoreByUserId();
      console.log("Total Score:", totalScore);
      const rankImage = getRankImage(parseInt(totalScore.totalScore));
      console.log("Rank Image:", rankImage);
      setRankImage(rankImage);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching total score:", error);
    }
  };

  useEffect(() => {
    const handleButtonClick = async () => {
      const access = sessionStorage.getItem("accessToken");
      // fetchData();
      const quizScoreLs: any = sessionStorage.getItem("quizScore");

      if (sessionStorage.getItem("scoreUpdated") === "true") {
        return;
      }

      try {
        // await BreefReportService.createBreefReport(parseInt(quizScoreLs), duration, totalScore, quizChances, setSnackbarMessage, setSnackbarSeverity, setSnackbarOpen);
        await BreefReportService.updateBreefTotalScore(
          totalScore.current,
          setSnackbarMessage,
          setSnackbarSeverity,
          setSnackbarOpen
        );
        sessionStorage.setItem("scoreUpdated", "true");
      } catch (error: any) {
        console.error("Error updating breef report:", error);
      }

      try {
        const breefCountResponse: any = await BreefReportService.getBreefCountByUserId();
        console.log("breef count", breefCountResponse);
        setBreefCount((breefCountResponse && breefCountResponse.numberOfBreefsSubmitted) || 0);
      } catch (error) {
        console.log("Error in fetching breef count", error);
      }

      // setTimeout(async () => {
      //     navigate("/home");
      // }, 10000);

      console.log("snackbarMessage", snackbarMessage);
    };
    handleButtonClick();
  }, []);

  return (
    <MobileLayout>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
        overflow: "hidden"
      }}>
        {!loading ? (
          <>
            <div
              style={{
                backgroundImage: `url(${rankImage.imageUrl || ""})`,
                overflow: "hidden",
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                flex: 1,
                width: "100%",
                position: "relative",
              }}
            >
              <p className="text-center">{totalScore.current}</p>
            </div>
          </>
        ) : (
          <div>Fetching....</div>
        )}
      </div>
    </MobileLayout>
  );
};

export default GameResult;